import { createSlice } from "@reduxjs/toolkit";
import { GetDashboard } from "services/dashboard/dashboard.service";
import { toast } from 'react-toastify';

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    dashboard: [],
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(GetDashboard.pending, () => {

    });

    builder.addCase(GetDashboard.fulfilled, (state, action) => {
      toast.dismiss();
      state.dashboard = action.payload
    });

    builder.addCase(GetDashboard.rejected, () => {
      toast.dismiss();
      toast.error('Promise rejected dashboard😣')
    });
  },
});

